export default __webpack_public_path__ + "static/media/11_bizum.2a5cae83.svg";